import { TEMPLATE_ID } from "./constants";

export const getConfigRequest = (fansUnitedSDK) => {
  return fansUnitedSDK.loyalty.getConfigV2(true);
}

export const getTemplateRequest = (fansUnitedSDK) => {
  return fansUnitedSDK.loyalty.getTemplateById(TEMPLATE_ID);
}

export const getMatchesRequest = (fansUnitedSDK, groupId = null) => {
  return fansUnitedSDK.loyalty.getTemplateMatches(TEMPLATE_ID, groupId);
};
